export enum SeriesType {
    Line = 'line',
    Column = 'column',
    Bar = 'bar',
    Scatter = 'scatter',
    Gauge = 'gauge',
    Pie = 'pie',
    Doughnut = 'doughnut',
    Candlestick = 'candlestick',
    Funnel = 'funnel',
    Radar = 'radar',
}